export const emailTemplates = {
	// Client Copy for Mailer
	C1: 'd-611dec81042a4f919d25f048beecf999', // Client sends bursary offer
};
